import z from "zod";

import type { TooltipContentProps } from "./Tooltip.types";

export const tooltipDataSchema = z.object({
  content: z
    .string()
    .optional()
    .describe(
      "Text shown in the tooltip. Falls back to the wrapped element's `title` attribute, which is then removed so the native tooltip doesn't double up.",
    ),
  side: z.custom<NonNullable<TooltipContentProps["side"]>>().optional(),
  sideOffset: z.coerce.number().optional(),
  align: z.custom<NonNullable<TooltipContentProps["align"]>>().optional(),
  alignOffset: z.coerce.number().optional(),
  arrow: z
    .string()
    .optional()
    .transform((value) =>
      value === undefined ? undefined : value !== "false",
    ),
  delay: z.coerce.number().optional(),
  closeDelay: z.coerce.number().optional(),
  disabled: z
    .string()
    .optional()
    .transform((value) => value !== undefined && value !== "false"),
});

export type TooltipDataProps = z.infer<typeof tooltipDataSchema>;
